import format from 'date-fns/format'
import dateSettings from './date.config'

export default {
  date: date => (date ? format(new Date(date), dateSettings.dateFormat) : ''),
  datetime: date => (date ? format(new Date(date), dateSettings.datetimeFormat) : '')
}
